export default __webpack_public_path__ + "static/media/image22.a1de426c.jpg";